import React from 'react';
import { Formik } from 'formik';

import { useCheckout } from '../../context';
import { CheckoutSteps } from '../../types';
import ScreeningForm from './components/ScreeningForm';

const RequestScreeningStep = () => {
  const { requestScreening, onSuccess, goToStep } = useCheckout();

  const goToTicketSelection = () => {
    goToStep(CheckoutSteps.TicketTiers);
  };

  const handleOnSubmit = (values) => {
    requestScreening.submitRequest(values).then(() => {
      onSuccess();
      goToStep(CheckoutSteps.SuccessRequestApproval);
    });
  };

  return (
    <Formik initialValues={{}} onSubmit={handleOnSubmit}>
      {(formProps) => (
        <ScreeningForm
          data={requestScreening.questions}
          goToTicketSelection={goToTicketSelection}
          error={requestScreening.error}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...formProps}
          isLoading={requestScreening.isLoading}
        />
      )}
    </Formik>
  );
};

export default RequestScreeningStep;
